import { render, staticRenderFns } from "./orderAuth.vue?vue&type=template&id=e6131342&scoped=true"
import script from "./orderAuth.vue?vue&type=script&lang=js"
export * from "./orderAuth.vue?vue&type=script&lang=js"
import style0 from "./orderAuth.vue?vue&type=style&index=0&id=e6131342&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6131342",
  null
  
)

export default component.exports